import { CommandButton } from '@fluentui/react/lib/Button';
import { IContextualMenuProps } from '@fluentui/react';
import { getAPIService } from "../../redux/Actions/PowerDataQuery";
import ExceptionReportDialog from "../CustomDialog/ExceptionReportDialog/ExceptionReportDialog";
import './IssueCenterPanel.css'
import { useEffect, useState } from "react";
import { Spinner, SpinnerSize } from 'office-ui-fabric-react';
import { useMsal, useAccount } from "@azure/msal-react";
import { useSearchParams } from 'react-router-dom';
import { formatDateToUTCStringDate } from '../Utilities/CommonFunction';
import CustomMessageAlert from "../CustomMessageAlert/CustomMessageAlert";
import { Stack, Link, DetailsList, DetailsListLayoutMode, IColumn, Dialog, DialogType, DialogFooter, DefaultButton,SelectionMode  } from '@fluentui/react';

interface IScanIssueData {
    content?: string;
    context?: string;
    category?: string;
    status?: string;
}

interface IIssueCenterPanelProps {
    title: string;
    showPanel: boolean;
    repoId?: string;
    surface?: string;
    onDismiss: () => void;
    originalIssueList: IScanIssueData[]
}

interface IListItem {
    content: string;
    context: string;
    category?: string;
    status: string;
}

interface IMessageState {
    showMessage: boolean,
    messageType: string,
    message: string,
    onDismiss?: () => void
}

const apiService = getAPIService().issueCenterService; 

export default function IssueCenterPanel(props: IIssueCenterPanelProps) {

    const [showReport, setShowReport] = useState<boolean>(false)

    const [reportType, setReportType] = useState<string>('')

    const [reportDetailCss, setReportDetailCss] = useState<string>('')

    const [isLoading, setIsLoading] = useState<boolean>(false)

    const [tableItems, setTableItems] = useState<IScanIssueData[]>([])

    const [currentExecuteRow, setCurrentExecuteRow] = useState(null);

    const [messageState, setMessageState] = useState<IMessageState>(() => {
        return {
            showMessage: false,
            messageType: '',
            message: '',
            onDismiss: null
        }
    })

    const { accounts } = useMsal()
    const userAccount = useAccount(accounts[0])
    const [search] = useSearchParams()

    const dismissReportDetail = () => {
        setReportDetailCss('report-detail-form-out')
        setTimeout(()=>{
            setShowReport(false)
        },500)
    }

    const dismissAlert = () => {
        setMessageState({
            messageType: '',
            showMessage: false,
            message: ''
        })
    }

    const submitReportDetail = async(exceptionType: string,businessJustificationValue: string,expirationDate: string) => {
        setIsLoading(true)
        const today = formatDateToUTCStringDate(new Date())
        const createParam = {
            issueData: [{
                articleUrl: search.get('url'),
                content: currentExecuteRow.tableItem.content,
                exceptionType: exceptionType,
                sourceApp: 'CHIRON',
                reporter: userAccount.username,
                reportTime: today,
                riskArea: 'BrokenLink',
                businessJustification: businessJustificationValue,
                startTime: today,
                repo: exceptionType == "Exception" ? props.repoId : null,
                surface: exceptionType == "Exception" ? props.surface : null,
                expireTime: formatDateToUTCStringDate(new Date(expirationDate)),
            }]
        }
        try {
            const data = await apiService.createIssueReport(createParam);
            if(data.success) {
                setMessageState({
                    messageType: 'success',
                    showMessage: true,
                    message: 'Successfully reported!'
                })
                setTimeout(()=>{
                    dismissAlert()
                }, 3000)
                setShowReport(false)
                getReportedBrokenLink()
            }
        }catch(error){
            setMessageState({
                messageType: 'error',
                showMessage: true,
                message: `Report failed, detail:${error.errorMessage ? error.errorMessage: 'Unknown error, please try again later!'}`,
                onDismiss: dismissAlert
            })
        }finally {
            setIsLoading(false)
        }
    }

    const getReportedBrokenLink = () => {
        setIsLoading(true)
        const requestUrl = search.get('url')
        const orgList = [...props.originalIssueList]
        apiService.getIssueList(requestUrl, userAccount.username, props.originalIssueList, 'BrokenLink').then(res => {
            res.issueData.forEach(issue => {
                orgList.forEach(item => {
                    if(item.content === issue.content && issue.issueId ) {
                        item.status = `Reported as ${issue.exceptionType}`
                    }
                })
            })
            setTableItems(orgList)
            setIsLoading(false)
        })
    }

    useEffect(()=>{
        if(props.originalIssueList?.length > 0) {
            getReportedBrokenLink()
        }
    }, [props.originalIssueList])

    /**
   * Render ContentId cell
   * @param rowIndex 
   * @param columnIndex 
   * @param tableColumn 
   * @param tableItem 
   * @returns 
   */
    // function renderChildLinkColumn(
    //     rowIndex: number,
    //     columnIndex: number,
    //     tableColumn: ITableColumn<IListItem>,
    //     tableItem: IListItem) {
    //     const { content } = tableItem

    //     return (
    //         <SimpleTableCell
    //             columnIndex={columnIndex}
    //             tableColumn={tableColumn}
    //             key={"col-" + columnIndex}
    //             contentClassName="bolt-table-cell-content-with-inline-link no-v-padding"
    //         >
    //             {
    //                 content && content.toString() !== '' ?
    //                     (
    //                         <Link
    //                             className="fontSizeM font-size-m text-ellipsis bolt-table-link bolt-table-inline-link"
    //                             excludeTabStop
    //                             href={content}
    //                             target={"_blank"}
    //                         >
    //                             {content}
    //                         </Link>
    //                     )
    //                     :
    //                     (
    //                         <div className="flex-row scroll-hidden">
    //                             {content}
    //                         </div>
    //                     )
    //             }

    //         </SimpleTableCell>
    //     );
    // }
    function renderChildLinkColumn(item: IListItem, index?: number) {
        const { content } = item;

        return content && content.toString() !== '' ? (
            <Link
                className="fontSizeM font-size-m text-ellipsis bolt-table-link bolt-table-inline-link"
                href={content}
                target="_blank"
                rel="noopener noreferrer"
                styles={{ root: { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block' } }}
            >
                {content}
            </Link>
        ) : (
            <div className="flex-row scroll-hidden">
                {content}
            </div>
        );
    }


    const buttonClick = (type: string, currentRow: {tableItem: IListItem, rowIndex: number}) => {
        setReportType(type)
        setShowReport(true)
        setCurrentExecuteRow(currentRow)
        setReportDetailCss('report-detail-form-in')
    }

    // function renderButtonCell(
    //     rowIndex: number,
    //     columnIndex: number,
    //     tableColumn: ITableColumn<IListItem>,
    //     tableItem: IListItem) {
    //         const menuProps: IContextualMenuProps = {
    //             onItemClick(ev, item) {
    //                 buttonClick(item.key,{tableItem,rowIndex})
    //             },
    //             items: [
    //                 {
    //                     key: 'falsePositive',
    //                     text: 'Report as false positive'
    //                 },
    //                 {
    //                     key: 'exception',
    //                     text: 'Set an exception'
    //                 },
    //             ]
    //         }
    //         return (
    //             <SimpleTableCell
    //                 columnIndex={columnIndex}
    //                 tableColumn={tableColumn}
    //                 key={tableColumn.id}
    //                 contentClassName="bolt-table-cell-content-with-inline-link no-v-padding"
    //                 >
    //                     {
    //                         tableItem.status === 'Broken' &&
    //                         <CommandButton iconProps={{iconName: 'Add'}} text="New action" menuProps={menuProps}/>
    //                     }
    //             </SimpleTableCell>
    //         )
    // }
    function renderButtonCell(item: IListItem, index?: number) {
        const menuProps: IContextualMenuProps = {
            items: [
                {
                    key: 'falsePositive',
                    text: 'Report as false positive',
                    onClick: () => buttonClick('falsePositive', { tableItem: item, rowIndex: index })
                },
                {
                    key: 'exception',
                    text: 'Set an exception',
                    onClick: () => buttonClick('exception', { tableItem: item, rowIndex: index })
                }
            ]
        };
    
        return item.status === 'Broken' ? (
            <CommandButton
                iconProps={{ iconName: 'Add' }}
                text="New action"
                menuProps={menuProps}
                styles={{ root: { padding: 0 } }}
            />
        ) : (
            <></>
        );
    }

    /**
     * build data list columns
     * @returns 
     */
    function buildColumns(): any {
        const columns = [
            {
                id: "content",
                name: "Link",
                minWidth: 500,
                maxWidth: 500,
                // renderCell: renderChildLinkColumn,
                onRender: renderChildLinkColumn,
                // sortProps: {
                //     ariaLabelAscending: "Sorted low to high",
                //     ariaLabelDescending: "Sorted high to low",
                // },
                // width: new ObservableValue(-1000),
            },
            {
                id: "context",
                name: "Link text",
                readonly: true,
                minWidth: 300,
                maxWidth: 300,
                onRender: (item: IListItem, index?: number) => {
                    return <span>{item.context}</span>;
                },
                // sortProps: {
                //     ariaLabelAscending: "Sorted low to high",
                //     ariaLabelDescending: "Sorted high to low",
                // },
                // width: new ObservableValue(-500),
            },
            {
                id: "status",
                name: "Status",
                readonly: true,
                minWidth: 200,
                maxWidth: 200,
                // renderCell: renderSimpleCell,
                onRender: (item: IListItem, index?: number) => {
                    return <span>{item.status}</span>;
                },
                // sortProps: {
                //     ariaLabelAscending: "Sorted low to high",
                //     ariaLabelDescending: "Sorted high to low",
                // },
                // width: new ObservableValue(-300),
            },
            {
                id: "actions",
                name: "Actions",
                minWidth: 200,
                maxWidth: 200,
                readonly: true,
                // renderCell: renderButtonCell,
                onRender: renderButtonCell,
                // width: new ObservableValue(-300),
            }

        ];

        return columns;
    }

    // const buildTableItems = () => {
    //     return new ArrayItemProvider<IListItem>(
    //         tableItems.map(item => {
    //             return {
    //                 content: item.content,
    //                 context: item.context,
    //                 status: item.status
    //             }
    //          })
    //     )
    // }
    const buildTableItems = () => {
        return tableItems.map(item => ({
            key: item.context,
            content: item.content,
            context: item.context,
            status: item.status
        }));
    };

    const closePanel = () => {
        setShowReport(false)
        props.onDismiss()
    }

    return (
        <>
            {
                props.showPanel &&
                <Dialog
                    // titleProps={{ text: props.title }}
                    // footerButtonProps={[
                    //     {
                    //         text: "Close",
                    //         onClick: closePanel
                    //     }
                    // ]}
                    // calloutContentClassName='issue-center-dialog'
                    onDismiss={closePanel}
                    hidden={false}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: props.title,
                    }}
                    modalProps={{
                        isBlocking: false,
                        className: 'issue-center-dialog'
                    }}
                >
                    <div style={{width: '100%', position: 'relative'}}>
                        <CustomMessageAlert
                            type={messageState.messageType}
                            message={messageState.message}
                            showAlert={messageState.showMessage}
                            onDismiss={messageState.onDismiss}
                        />
                    </div>
                    {
                        showReport ? 
                        // <Card className={reportDetailCss}>
                        <Stack tokens={{ childrenGap: 8 }} className={reportDetailCss}>
                            <div style={{width: '100%'}}>
                                <ExceptionReportDialog
                                    showReportExceptionDialog={showReport}
                                    dismissReportDialog={dismissReportDetail}
                                    onSubmit={submitReportDetail}
                                    reportType={reportType}
                                />
                            </div>
                        </Stack> :
                        // <Card className="flex-grow bolt-table-card report-detail-list" contentProps={{ contentPadding: false }}>
                        <Stack tokens={{ childrenGap: 8 }} className="flex-grow bolt-table-card report-detail-list">
                            {/* <Table
                                ariaLabel="Basic Table"
                                columns={buildColumns()}
                                itemProvider={buildTableItems()}
                                role="table"
                                className="issue-center-table"
                                containerClassName="h-scroll-auto"
                            /> */}
                                    <DetailsList
                                        items={buildTableItems()}
                                        columns={buildColumns()}
                                        setKey="set"
                                        selectionMode={SelectionMode.none}
                                        layoutMode={DetailsListLayoutMode.fixedColumns}
                                        className="issue-center-table"
                                        styles={{
                                            root: {
                                                overflowX: 'auto',
                                                border: '1px solid #e1e1e1',
                                                borderRadius: 4,
                                            },
                                            headerWrapper: {
                                                borderBottom: '1px solid #d0d0d0',
                                                backgroundColor: '#f9f9f9',
                                            },
                                            contentWrapper: {
                                                selectors: {
                                                    '.ms-DetailsRow': {
                                                        borderBottom: '1px solid #f0f0f0',
                                                        minHeight: 40,
                                                    },
                                                    '.ms-DetailsRow:hover': {
                                                        backgroundColor: '#f3f9fd',
                                                    },
                                                    '.ms-DetailsHeader-cellTitle': {
                                                        fontWeight: 600,
                                                    },
                                                },
                                            },
                                        }}
                                    />

                        </Stack>
                    }
                    {
                        isLoading && <Spinner className='issue-center-loading' label='Loading...' size={SpinnerSize.large} />
                    }

                    <DialogFooter>
                        <DefaultButton onClick={closePanel} text="Close" />
                    </DialogFooter>
                </Dialog>
            }
        </>
    )

}